import React, { Component } from 'react'
import Footer from '../components/footer/Footer'
import NavbarOne from '../components/navbars/NavbarOne'
import SideNavbar from '../components/navbars/SideNavbar'
import { Container } from 'react-bootstrap'
import AdaptiveExams from '../components/adaptiveExams/AdaptiveExams'
import * as Cookies from "es-cookie";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

class AdaptiveExaminations extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />

                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                        <Container fluid>
                            <AdaptiveExams />
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default AdaptiveExaminations